"use strict";

var __importDefault = void 0 && (void 0).__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

const Close_1 = __importDefault(require("@mui/icons-material/Close"));

const ExpandLess_1 = __importDefault(require("@mui/icons-material/ExpandLess"));

const ExpandMore_1 = __importDefault(require("@mui/icons-material/ExpandMore"));

const material_1 = require("@mui/material");

const classnames_1 = __importDefault(require("classnames"));

const react_1 = __importDefault(require("react"));

const PREFIX = 'SskyExpandedDialog';
const classes = {
  appBar: `${PREFIX}-appBar`,
  toolBarRoot: `${PREFIX}-toolBarRoot`,
  flex: `${PREFIX}-flex`,
  icon: `${PREFIX}-icon`,
  buttons: `${PREFIX}-buttons`,
  sskyDialog: `${PREFIX}-sskyDialog`,
  paper: `${PREFIX}-paper`
};
const StyledDialog = (0, material_1.styled)(material_1.Dialog)(() => ({
  [`& .${classes.appBar}`]: {
    position: "relative",
    backgroundColor: "#323232",
    overflow: "hidden",
    minWidth: 300,
    maxHeight: 55,
    boxShadow: "none"
  },
  [`& .${classes.toolBarRoot}`]: {
    padding: "0 12px 0 20px",
    minHeight: 55
  },
  [`& .${classes.flex}`]: {
    flex: 1,
    fontSize: 14,
    color: "white",
    fontWeight: 400,
    marginRight: 10
  },
  [`& .${classes.icon}`]: {
    color: "white"
  },
  [`& .${classes.buttons}`]: {
    width: 35
  },
  [`& .${classes.sskyDialog}`]: {
    right: 24,
    left: "auto",
    top: "auto",
    position: "absolute",
    minWidth: 350,
    maxWidth: 500,
    display: "block",
    maxHeight: 350
  },
  [`& .${classes.paper}`]: {
    boxShadow: "0 2px 8px 0 rgba(0,0,0,.2)",
    marginBottom: 20
  }
}));

const SskyExpandedDialog = props => {
  function Transition(props) {
    return react_1.default.createElement(material_1.Slide, Object.assign({
      direction: "up"
    }, props));
  }

  return react_1.default.createElement(StyledDialog, {
    className: (0, classnames_1.default)(props.className),
    classes: {
      paper: classes.paper
    },
    style: {
      right: 24,
      left: "auto",
      top: "auto",
      position: "absolute",
      minWidth: 350,
      maxWidth: 500,
      display: "block",
      maxHeight: 350
    },
    open: props.open,
    onClose: props.onClose,
    hideBackdrop: true,
    TransitionComponent: Transition,
    "data-testid": props.dataTestId
  }, react_1.default.createElement(material_1.AppBar, {
    className: classes.appBar
  }, react_1.default.createElement(material_1.Toolbar, {
    classes: {
      root: classes.toolBarRoot
    }
  }, react_1.default.createElement(material_1.Typography, {
    variant: "h6",
    className: classes.flex
  }, props.message), react_1.default.createElement(material_1.IconButton, {
    onClick: props.onExpand,
    classes: {
      root: classes.buttons
    }
  }, props.expanded ? react_1.default.createElement(ExpandMore_1.default, {
    className: classes.icon
  }) : react_1.default.createElement(ExpandLess_1.default, {
    className: classes.icon
  })), react_1.default.createElement(material_1.IconButton, {
    onClick: props.onClose,
    classes: {
      root: classes.buttons
    }
  }, react_1.default.createElement(Close_1.default, {
    className: classes.icon
  })))), props.expanded && props.children);
};

exports.default = react_1.default.memo(SskyExpandedDialog);